import { Action, ThunkAction } from "@reduxjs/toolkit";
import { Sendum, Models, Types, Enums, Services, Components } from "@sendum/core";

// import MqttClient from "../../../services/MQTT/MqttClient";

import { TFilter } from "../types/TFilter";

import { DeviceSelectorRootState, DispatchAction } from "./DeviceSelectorStore";
// TODO
import { IDeviceSelectorState } from "./DeviceSelectorReducer";
import { AnyAction } from "redux";
// import * as MQTTActions from "../../../services/MQTT/MQTTActions";

export enum DeviceSelectorActionTypes {
	SET_SORT_BY,
	SET_COUNTS_FILTER,
	SET_SORT_DIRECTION,
	SET_SEARCH,
	SET_FILTER,
	SET_LIMIT,
	SET_LOAD_DEVICES_QUERY,
	SET_LOADING_DEVICES,
	END_INITIAL_LOADING_DEVICES,
	SET_FILTERING,
	CLEAR_DEVICES,
	ADD_DEVICES,
	SET_COUNTS,
	UPDATE_DEVICE_MQTT,
	SET_ERROR,
	RESET_STATE
}

export const resetState = (): DispatchAction => ({
	type: DeviceSelectorActionTypes.RESET_STATE,
	payload: {},
});

export const setSortBy = (sortBy: Enums.SortBy): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_SORT_BY,
	payload: {
		sortBy,
	},
});

export const setCountsFilter = (countsFilter: Components.Counts.ECountsItem): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_COUNTS_FILTER,
	payload: {
		countsFilter,
	},
});

export const setSortDirection = (sortDirection: Enums.SortDirection): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_SORT_DIRECTION,
	payload: {
		sortDirection,
	},
});

export const setSearch = (search: string): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_SEARCH,
	payload: {
		search,
	},
});

export const setFilter = (filter: TFilter): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_FILTER,
	payload: {
		filter,
	},
});

export const setLimit = (limit: number): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_LIMIT,
	payload: {
		limit,
	},
});

export const setLoadDevicesQuery = (query: Types.TLoadDevicesQuery): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_LOAD_DEVICES_QUERY,
	payload: {
		query,
	},
});

export const setLoadingDevices = (newState: boolean): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_LOADING_DEVICES,
	payload: {
		newState,
	},
});

export const endInitialLoadingDevices = (): DispatchAction => ({
	type: DeviceSelectorActionTypes.END_INITIAL_LOADING_DEVICES,
	payload: {},
});

export const setFiltering = (newState: boolean): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_FILTERING,
	payload: {
		newState,
	},
});

export const clearDevices = (): DispatchAction => ({
	type: DeviceSelectorActionTypes.CLEAR_DEVICES,
	payload: {},
});

export const addDevices = (devices: Models.Device[]): DispatchAction => ({
	type: DeviceSelectorActionTypes.ADD_DEVICES,
	payload: {
		devices,
	},
});

export const setCounts = (counts: Models.Counts): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_COUNTS,
	payload: {
		counts,
	},
});

export const updateDeviceByMqtt = (mess: any, topic: string): DispatchAction => ({
	type: DeviceSelectorActionTypes.UPDATE_DEVICE_MQTT,
	payload: {
		mess,
		topic,
	},
});

export const setError = (error: Error): DispatchAction => ({
	type: DeviceSelectorActionTypes.SET_ERROR,
	payload: {
		error,
	},
});

export const loadDevices = (offset = 0, clear = false): ThunkAction<void, DeviceSelectorRootState, null, Action<string>> => async (dispatch, getState) => {
	// TODO
	const state: IDeviceSelectorState = getState().DeviceSelector;
	if (state.isLoadingDevices) {
		return;
	}

	await dispatch(setLoadingDevices(true) as unknown as AnyAction);
	const query: Types.TLoadDevicesQuery = {
		view: "cards",
		offset,
		limit: state.limit || 10,
		search: state.search || "",
		countsFilter: state.countsFilter ? Components.Counts.eCountsItemMap.get(state.countsFilter) : Components.Counts.eCountsItemMap.get(Components.Counts.ECountsItem.TOTAL),
		shipmentStatus: state.filter?.shipmentStatuses || [],
		deviceStatus: state.filter?.deviceStatuses || [],
		sortBy: state.sortBy || Enums.SortBy.UPDATED_AT,
		sortDirection: state.sortDirection || Enums.SortDirection.ASC,
	};

	await dispatch(setLoadDevicesQuery(query));
	try {
		// const isInitiated = Services.DeviceConfigService.DeviceConfig.getInstance().init(await Services.API.WidgetsApi.getConfig());
		//
		// if (!isInitiated) {
		// 	dispatch(setError(new Error("Widget was not configured completely.")));
		// }
		const response = await Services.API.WidgetsApi.getDevices(Types.printLoadDevicesQueryToRequest(query));
		if (clear) {
			await dispatch(clearDevices());
			// TODO MQTTActions.unsubscribe();
		}
		await dispatch(addDevices(response.devices));
		await dispatch(setCounts(Models.Counts.parse(response.itemsCounts)));
		await dispatch(setLoadingDevices(false));
		await dispatch(setFiltering(false));

		if (state.isInitialLoadingDevices) {
			await dispatch(endInitialLoadingDevices());
		}

		const shipmentsIds: Set<string> = new Set<string>();
		response.devices.forEach(d => {
			if (d?.shipment?.id) {
				shipmentsIds.add(`shipment/${d.shipment.id}`);
			}
		});
		// TODO MqttClient.subscribe(Array.from(shipmentsIds));
	} catch (err) {
		console.error(err);
		dispatch(setLoadingDevices(false));
		dispatch(setFiltering(false));
		dispatch(setError(err));
	}
};
